import React from "react";
import { withStyles, makeStyles } from '@mui/styles';
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";

import Modal from "./Test/WindowSwitch/SwitchModal";
import { Grid } from "@mui/material";
import { LoaderProcessingOutlined } from "./LoaderProcessing";
import modalHandler from "../utils/modalHandler";
import LanguageModal from "./Test/LanguageModal";
import { useSelector } from "react-redux";
import { getUserHomeDetails } from "../reducer/dashboardSlice";
const _StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

// const formattedDate = date.toLocaleDateString('en-GB', {
//   day: 'numeric', month: 'short', year: 'numeric'
// }).replace(/ /g, '-');

const _StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 340,
  },
  root: {
    background: "transparent",
    boxShadow: "none",
  },
  tableCell: {
    paddingRight: 4,
    paddingLeft: 5,
  },
  // Listing Layout Styles
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
    border: "1px solid #e8e8e8",
  },
  listHeader: {
    display: "grid",
    gridTemplateColumns: "2fr 120px 1.5fr 170px",
    gap: "24px",
    padding: "14px 24px",
    background: "#fafafa",
    borderBottom: "1px solid #e8e8e8",
    fontSize: "12px",
    fontWeight: 600,
    color: "#666",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    '@media (max-width: 768px)': {
      display: "none",
    },
  },
  listItem: {
    display: "grid",
    gridTemplateColumns: "2fr 120px 1.5fr 170px",
    gap: "24px",
    padding: "16px 24px",
    alignItems: "center",
    borderBottom: "1px solid #f0f0f0",
    transition: "all 0.15s ease",
    "&:last-child": {
      borderBottom: "none",
    },
    "&:hover": {
      background: "#fafbfc",
    },
    '@media (max-width: 768px)': {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
      padding: "16px 20px",
    },
  },
  listItemInProgress: {
    borderLeft: "3px solid #ff9800",
    background: "linear-gradient(90deg, rgba(255, 152, 0, 0.03) 0%, transparent 100%)",
    "&:hover": {
      background: "linear-gradient(90deg, rgba(255, 152, 0, 0.06) 0%, #fafbfc 100%)",
    },
  },
  listItemNotStarted: {
    borderLeft: "3px solid #6f2981",
    background: "linear-gradient(90deg, rgba(111, 41, 129, 0.02) 0%, transparent 100%)",
    "&:hover": {
      background: "linear-gradient(90deg, rgba(111, 41, 129, 0.04) 0%, #fafbfc 100%)",
    },
  },
  testNameCell: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
    '@media (max-width: 768px)': {
      width: "100%",
    },
  },
  testName: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a1a",
    margin: 0,
    lineHeight: 1.4,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "default",
  },
  statusCell: {
    display: "flex",
    justifyContent: "center",
    '@media (max-width: 768px)': {
      order: -1,
      justifyContent: "flex-start",
    },
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    padding: "5px 12px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 500,
    whiteSpace: "nowrap",
    minWidth: "95px",
  },
  statusDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
  },
  statusNotStarted: {
    background: "rgba(111, 41, 129, 0.08)",
    color: "#6f2981",
    "& $statusDot": {
      background: "#6f2981",
    },
  },
  statusInProgress: {
    background: "rgba(255, 152, 0, 0.1)",
    color: "#e65100",
    "& $statusDot": {
      background: "#ff9800",
    },
  },
  scheduleCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontSize: "13px",
    color: "#555",
    '@media (max-width: 768px)': {
      width: "100%",
      padding: "8px 0",
      borderTop: "1px solid #f0f0f0",
      borderBottom: "1px solid #f0f0f0",
      justifyContent: "flex-start",
    },
  },
  scheduleIcon: {
    width: "16px",
    height: "16px",
    color: "#888",
    flexShrink: 0,
  },
  scheduleText: {
    fontWeight: 500,
    color: "#333",
  },
  actionCell: {
    display: "flex",
    justifyContent: "center",
    '@media (max-width: 768px)': {
      width: "100%",
      justifyContent: "stretch",
    },
  },
  actionButton: {
    borderRadius: "6px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "13px",
    padding: "8px 16px",
    minWidth: "160px",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(111, 41, 129, 0.25)",
    },
    "&.Mui-disabled": {
      backgroundColor: "#d1d5db",
      color: "#9ca3af",
      cursor: "not-allowed",
      pointerEvents: "auto",
    },
    '@media (max-width: 768px)': {
      width: "100%",
      minWidth: "unset",
    },
  },
  // Empty state
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 24px",
    textAlign: "center",
    background: "#fff",
    borderRadius: "12px",
    border: "1px solid #e8e8e8",
  },
  emptyIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "#f5f0f7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
  },
  emptyTitle: {
    margin: "0 0 8px 0",
    fontSize: "17px",
    fontWeight: "600",
    color: "#333",
  },
  emptyText: {
    margin: "0",
    fontSize: "14px",
    color: "#666",
    maxWidth: "300px",
    lineHeight: 1.5,
  },
  // Mobile label
  mobileLabel: {
    display: "none",
    fontSize: "11px",
    fontWeight: 600,
    color: "#888",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "4px",
    '@media (max-width: 768px)': {
      display: "block",
    },
  },
});

export default function CustomizedTables(props) {
  const classes = useStyles();
  const { tableData, _status, typeButton, _setModal, _setTestData, examId, _setExamId, buttonName, setCodeLanguages } = props;
  const [msgModal, setMsgModal] = React.useState(false);
  const [showModel, setModelShow] = React.useState(false);
  const [_ind, setInd] = React.useState(0);
  const [loading, setLoading] = React.useState({ index: "", status: false, name: "" });
  const [resumeLoader, setResumeLoader] = React.useState({ index: "", status: false, name: "" });
  const [messageModal, setMessageModal] = React.useState("");
  const [message, setMessage] = React.useState("");
  // const [showtb, setShowtb] = React.useState(tableData === undefined ? false : true);
  const [showLanguageModal, setShowLanguageModal] = React.useState(false);
  const [modalHandlerData, setModalHandlerData] = React.useState({});
  const userHomeData = useSelector(getUserHomeDetails);

  if (tableData["tableHeaders"] !== undefined) {
    //  tableData['001']!===undefined?setInd(tableData['001'].length):setInd(0) ;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    tableData["001"] !== undefined ? setInd(tableData["001"].length) : setInd(0);
    // setInd(tableData['001'].length );
  });

  window.onunload = function (event) {
    // onload event handler
    event.preventDefault();
    window.localStorage.removeItem(examId);
  };

  return (
    <Grid item xs={12}>
      <Paper className={classes.root}>
        {/* #8080801f */}
        {userHomeData && userHomeData.workflowMessage && userHomeData.workflowMessage.message && (
          <div style={{ margin: "15px 0", padding: "10px 20px", color: "#00BAD1", backgroundColor: "#D0EDF4", border: "1px solid #00BAD1" }}>
            {userHomeData.workflowMessage.message}
          </div>
        )}
        {tableData && tableData[Object.keys(tableData)[0]] !== undefined ? (
        <div className={classes.listContainer}>
          {/* List Header */}
          <div className={classes.listHeader}>
            <span>Name</span>
            <span style={{ textAlign: "center" }}>Status</span>
            <span style={{ textAlign: "center" }}>Scheduled</span>
            <span style={{ textAlign: "center" }}>Action</span>
          </div>

          {/* In Progress Tests */}
          {tableData["001"] !== undefined && tableData["001"].map((row, index) => (
            <div key={`inprogress-${index}`} className={`${classes.listItem} ${classes.listItemInProgress}`}>
              <div className={classes.testNameCell}>
                <h3 className={classes.testName} title={row.examName}>{row.examName}</h3>
              </div>

              <div className={classes.statusCell}>
                <span className={`${classes.statusBadge} ${classes.statusInProgress}`}>
                  <span className={classes.statusDot}></span>
                  In Progress
                </span>
              </div>

              <div className={classes.scheduleCell}>
                <svg className={classes.scheduleIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <span className={classes.scheduleText}>
                  {new Date(row.date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }).replace(/ /g, "-")}
                  {" \u2022 "}
                  {new Date(row.date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })}
                </span>
              </div>

              <div className={classes.actionCell}>
                {resumeLoader.status && resumeLoader.index === index && resumeLoader.name === `resume_${buttonName}_${index}` ? (
                  <LoaderProcessingOutlined />
                ) : (
                  <Button
                    variant="contained"
                    name={`resume_${buttonName}_${index}`}
                    color="primary"
                    className={classes.actionButton}
                    onClick={(e) =>
                      modalHandler(
                        row,
                        index,
                        e,
                        props,
                        setLoading,
                        setModelShow,
                        setMsgModal,
                        setResumeLoader,
                        setMessageModal,
                        setMessage,
                        setCodeLanguages
                      )
                    }
                  >
                    Resume Test
                  </Button>
                )}
              </div>
            </div>
          ))}

          {/* Not Started Tests */}
          {tableData["000"] !== undefined && tableData["000"].map((row, index) => (
            <div key={`notstarted-${index}`} className={`${classes.listItem} ${classes.listItemNotStarted}`}>
              <div className={classes.testNameCell}>
                <h3 className={classes.testName} title={row.examName}>{row.examName}</h3>
              </div>

              <div className={classes.statusCell}>
                <span className={`${classes.statusBadge} ${classes.statusNotStarted}`}>
                  <span className={classes.statusDot}></span>
                  Not Started
                </span>
              </div>

              <div className={classes.scheduleCell}>
                <svg className={classes.scheduleIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <span className={classes.scheduleText}>
                  {new Date(row.date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }).replace(/ /g, "-")}
                  {" \u2022 "}
                  {new Date(row.date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })}
                </span>
              </div>

              <div className={classes.actionCell}>
                {loading.status && loading.index === index && loading.name === `TakeTest_${buttonName}_${index}` ? (
                  <LoaderProcessingOutlined />
                ) : (
                  <Button
                    name={`TakeTest_${buttonName}_${index}`}
                    disabled={new Date(row.date) > new Date()}
                    variant="contained"
                    color="primary"
                    className={classes.actionButton}
                    onClick={
                      row.languageLocale !== null && row.languageLocale.split(",").length > 1
                        ? (e) => {
                            setModalHandlerData({
                              row,
                              index,
                              name: e.currentTarget.name,
                              userExamId: row.userExamId,
                              props,
                              setLoading,
                              setModelShow,
                              setMsgModal,
                              setResumeLoader,
                              setMessageModal,
                              setMessage,
                              setCodeLanguages,
                            });
                            setShowLanguageModal(true);
                          }
                        : (e) => {
                            modalHandler(
                              row,
                              index,
                              e.currentTarget.name,
                              props,
                              setLoading,
                              setModelShow,
                              setMsgModal,
                              setResumeLoader,
                              setMessageModal,
                              setMessage,
                              setCodeLanguages,
                              row.languageLocale
                            );
                          }
                    }
                  >
                    {`Take ${typeButton === "Survey" ? "Survey" : "Test"} Online`}
                  </Button>
                )}
              </div>

              {showLanguageModal && (
                <LanguageModal
                  showLanguageModal={showLanguageModal}
                  setShowLanguageModal={setShowLanguageModal}
                  modalHandlerData={modalHandlerData}
                />
              )}
            </div>
          ))}
        </div>
        ) : (
          <div className={classes.emptyState}>
            <div className={classes.emptyIcon}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#7030a0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 11l3 3L22 4"></path>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
            </div>
            <h4 className={classes.emptyTitle}>
              {typeButton === "Feedback"
                ? "No Pending Feedback"
                : typeButton === "Survey"
                ? "No Pending Survey"
                : typeButton === "WorkFlow"
                ? "No Pending WorkFlow"
                : "No Pending Tests"}
            </h4>
            <p className={classes.emptyText}>
              {typeButton === "WorkFlow" && userHomeData && userHomeData.isWorkflowInProgress === true
                ? "Your result is being processed. Please refresh your screen within the next 2 minutes to check for the next step."
                : "You're all caught up! Check back later for new items."}
            </p>
          </div>
        )}
        {/* <Table className={classes.table} aria-label="customized table">
        <TableHead className="thead-dark">
          <TableRow>
            {
              tableData['tableHeaders'] !== undefined ?
              tableData['tableHeaders'].split(',').map((item,index) => {
                return (<StyledTableCell key={index}>{item}</StyledTableCell>)
              })
              :
              <></>
            }


          </TableRow>
        </TableHead>
        <TableBody>
          {
            tableData['001'] !== undefined ?
              tableData['001'].map((row, index) => {
                return(
                  <StyledTableRow key={`${'001'}_${index}`}>
                    <StyledTableCell  component="th" scope="row">
                      {index+1}
                    </StyledTableCell>
                    <StyledTableCell >{row.examName}</StyledTableCell>
                    <StyledTableCell >IN PROGRESS</StyledTableCell>
                    <StyledTableCell >{row.date}</StyledTableCell>
                    <StyledTableCell>
                      <Button variant="outlined" color="primary" onClick={() => modalHandler(row)}>
                      Resume
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            :
            <></>
          }
          {
            tableData['000'] !== undefined ?
              tableData['000'].map((row, index) => {
                return(
                  <StyledTableRow key={`${'000'}_${index}`}>
                    <StyledTableCell  component="th" scope="row">
                      {ind+index+1}
                    </StyledTableCell>
                    <StyledTableCell >{row.examName}</StyledTableCell>
                    <StyledTableCell >NOT STARTED</StyledTableCell>
                    <StyledTableCell >{row.date}</StyledTableCell>
                    <StyledTableCell>
                      <Button variant="outlined" color="primary" onClick={() => modalHandler(row)}>
                      {`Take ${typeButton === 'Survey' ? 'Survey' : 'Test'} Online`}
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            :
            <></>
          }

        </TableBody>
      </Table> */}
        {msgModal ? <Modal headerMessage={messageModal} message={message ? message : ""} showModel={showModel} /> : <> </>}
      </Paper>
      {tableData && Array.isArray(tableData) && tableData.some(row => new Date(row.date) > new Date()) && (
        <p style={{ fontSize: "12px", color: "#8D0001", marginTop: "8px", marginBottom: 0, textAlign: "center" }}>
          Note: You can attempt the test only after the scheduled date and time
        </p>
      )}
    </Grid>
  );
}
